






































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { invertColor } from "@/helpers/color";
import { ITag } from "@/models/tags";

@Component
export default class TagsCloudView extends Vue {
  @Prop({ required: true })
  public availableTags!: any[];

  @Prop({ default: () => [] })
  public selectedTags!: any[];

  @Prop({ default: true })
  public showTooltips!: boolean;

  @Prop({ default: false })
  public closable!: boolean;

  @Prop({ default: "id" })
  public orderByField!: string;

  @Prop({ default: true })
  public canSelect!: boolean;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: false })
  public loading!: boolean;

  public invertColor(color, bw) {
    return invertColor(color, bw);
  }

  public get availableTagsOrdered() {
    return this.$_.orderBy(this.availableTags, this.orderByField);
  }

  public get selectedTagIds() {
    return this.selectedTags.map(tag => tag.id);
  }

  // Methods

  public onClick(tag: ITag) {
    this.canSelect && !this.disabled && this.$emit("select-tag", tag);
  }

  public onClose(tag: ITag) {
    this.$emit("tag-close", tag);
  }
}
